import strings from './FieldStrings.resx';

/**
 * @internal
 */
export function getBooleanDisplayValue(value: boolean): string {
    return value ? strings.Yes : strings.No;
}
